import React from 'react';

import { staticRoutes } from 'Deer/constants/routes';
import { Redirect } from 'react-router-dom';
import { checkSimplifiedReviewCreationEnabled } from 'utils/helpers/featureFlags';
import { checkUserIsCustomReviewAdmin, checkUserIsReviewAdmin } from 'utils/helpers/rolesAccess';

import { ReviewProcessV1 } from './ReviewProcessV1';

export const ReviewProcessSelectorWrapper = () => {
  if (!checkUserIsReviewAdmin() && !(checkSimplifiedReviewCreationEnabled() && checkUserIsCustomReviewAdmin())) {
    return <Redirect to={{ pathname: staticRoutes.home }} />;
  }

  return <ReviewProcessV1 />;
};
